import { CompanyFile, CompanySignupV5Payload, FileStatus } from '@hum/types';
import { createMutation } from '../../utils/createMutation';

export const getCompanyUuid = createMutation<
  { uuid: string },
  { companyId: number }
>(({ api, payload }) => {
  return api.get(`/companies/${payload.companyId}`).then((res) => ({
    uuid: res.uuid,
  }));
});

export const updateSignUpCompany = createMutation<
  CompanySignupV5Payload & { companyId: number }
>(
  ({ api, payload }) => {
    return api.patch(`/v1/companies/${payload.companyId}/signup`, {
      user: {
        companyPosition: payload.companyPosition,
      },
      name: payload.companyName,
      website: payload.website,
      state: payload.state ? payload.state : payload.location,
      country: payload.country,
      application: {
        yearFounded: payload.application?.yearFounded,
        selfReportedIndustry: payload.application?.selfReportedIndustry,
        revenueModel: payload.application?.revenueModel,
        investmentAmount: payload.application?.investmentAmount,
        fundraisingTimeFrame: payload.application?.fundraisingTimeFrame,
        fundingType: payload.application?.fundingType,
        useOfFunds: payload.application?.useOfFunds,
        capitalDeployment: payload.application?.capitalDeployment,
        lastFundingRound: payload.application?.lastStageOfFunding,
        lastRaised: payload.application?.dateOfLastRaise,
        equityRaised: payload.application?.totalEquityRaised,
        latestPostMoneyValuation: payload.application?.lastValuation,
        reviewAndConfirmBy: payload.application?.reviewAndConfirmBy,
      },
    });
  },
  {
    invalidates: ['/companies'],
    successToast: { message: 'Company info saved!' },
    errorToast: { message: 'Failed to save company data' },
  }
);

export const downloadCompanyFile = createMutation<
  { downloadUrl: string; file: CompanyFile },
  { companyId?: string; fileId?: number }
>(
  ({ api, payload, session, router }) => {
    const isAdmin = session.user?.isAdmin;
    const companyId = isAdmin
      ? router.query.company_id
      : payload?.companyId || session.user?.organizationId;
    const fileId = payload?.fileId;

    if (!companyId) {
      return Promise.reject(new Error('Company ID is required'));
    }
    if (!fileId) {
      return Promise.reject(new Error('File ID is required'));
    }

    const baseUrl = '/v2/companies';
    const url = `${baseUrl}/${companyId}/files/${fileId}/download`;

    return api.get(url).then((res) => res || []);
  },
  { mutationKey: ['downloadCompanyFile'] }
);

export const updateCompanyFile = createMutation<
  CompanyFile,
  { companyId: string; fileId: number; status?: FileStatus; meta?: any }
>(({ api, payload }) => {
  return api.patch(
    `/v2/companies/${payload.companyId}/files/${payload.fileId}`,
    {
      ...(payload.status ? { status: payload.status } : {}),
      ...(payload.meta ? { meta: payload.meta } : {}),
    }
  );
});
